import React from 'react';
import { useAppSelector } from 'redux/store';
import { Icon } from 'components/icon/icon';
import { Typography } from 'components/typography';
import IconChevronRight from 'public/assets/icons/chevron-right.svg';
import styles from './filter-sidebar.module.scss';

export interface IFilterGroupTitle {
	title: string;
	identifier: string;
	setCurrentFilter: ({ identifier, title }: { identifier: string; title: string }) => void;
	onEnter: (event: React.KeyboardEvent<HTMLDivElement>, identifier: string, title: string) => void;
}

export const FilterGroupTitle = ({
	title,
	identifier,
	setCurrentFilter,
	onEnter
}: IFilterGroupTitle): React.JSX.Element => {
	const { activeFilters } = useAppSelector((state) => state.subsidy);
	const matchingFilters = activeFilters.filter((filter) => filter.key === identifier).map((item) => item.label);
	const filtersString = matchingFilters ? matchingFilters.join(', ') : undefined;

	return (
		<Typography
			tag="span"
			variant="h4"
			onClick={() => setCurrentFilter({ identifier, title })}
			onKeyUp={(event) => onEnter(event, identifier, title)}
			role="button"
			tabIndex={0}
		>
			{title}
			<span className={styles.activeFiltersList}>{filtersString}</span>
			<Icon customIcon={<IconChevronRight />} size="14px" />
		</Typography>
	);
};
